import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';
import { scrollBarNoHeight } from 'src/styles/styles';
import { flex } from 'src/styles/utils';
export const Container = styled.div`
  width: 100%;
  height: fit-content;
  border: 1px solid ${colors.PlanContainer};
  ${flex('column', 'space-around', 'flex-start')};
  gap: 8px;
  padding: 16px;
  color: ${colors.PrimaryWhiteColor};
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px ${rgba(colors.black, 0.25)};
  background: linear-gradient(335deg, #2a272b 52%, #6150a9 100%);
`;
export const premiumContainer = css`
  background: linear-gradient(
    146deg,
    #10151a 0.77%,
    #362f63 31.32%,
    #0c090e 63.75%
  );
`;
export const Header = styled.div`
  ${ZeeFontBold(18, 24)};
  ${MediaBP.MediaMd} {
    ${ZeeFontBold(24, 36)};
  }
`;
export const Description = styled.div`
  ${ZeeFontRegular(12, 16)};
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(18, 24)};
  }
`;
export const whitePill = css`
  background: ${colors.PrimaryWhiteColor};
  border-color: ${colors.PrimaryWhiteColor};
`;
export const goldPill = css`
  background: ${colors.YellowGold};
  border-color: ${colors.YellowGold};
`;
export const transparentPill = css`
  border-color: ${colors.PrimaryWhiteColor};
  color: ${colors.PrimaryWhiteColor};
`;
export const Pill = styled.button`
  border-radius: 48px;
  padding: 9px;
  background: none;
  border: 1px solid;
  color: ${colors.PrimaryBlackColor};
  white-space: nowrap;
  transition: background 0.2s ease-out 0.1s, color 0.2s;
  cursor: pointer;
`;

export const PillsContainer = styled.div`
  width: 100%;
  background: none;
  ${flex('row', 'start')};
  gap: 8px;
  margin-top: 24px;
  overflow-y: scroll;
  ${scrollBarNoHeight}
`;

export const FeaturesContainer = styled.div`
  ${flex('row', 'space-between')};
  width: 100%;
  margin-top: 24px;
`;

export const PlanCardContainer = styled.div`
  ${flex('row', 'space-around')};
  width: 100%;
  margin-top: 16px;
  gap: 8px;
  overflow-y: auto;
  ${scrollBarNoHeight};
`;
